.wrapper {
  position: relative;
  padding: 40px 20px 0px;
  background: #fffbf2;
}

.badge {
  position: absolute;
  top: 24px;
  left: 50%;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 24px;
  transform: translateX(-50%);
  background: #ae66f6;
  box-shadow: inset 1px -3px 16px 0 rgba(255, 255, 255, 0.6);
  color: #fffbf2;
  white-space: nowrap;

  span {
    font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.056px;
    text-transform: uppercase;
  }
}

.sparkle {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.card {
  margin: 0 auto;
  padding: 28px 8px 8px;
  border-radius: 32px;
  background: #f2ede1;
  box-sizing: border-box;
}

.title {
  margin: 0 auto 20px;
  max-width: 265px;
  color: #221e1a;
  text-align: center;
  font-family: ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
}

.content {
  padding: 12px 8px 20px;
  border-radius: 24px 24px 28px 28px;
  background: #fffefb;
}

.tabs {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.tabSlot {
  flex: 1 0 0;
  display: flex;
  justify-content: center;
}

.tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 4px 8px;
  border-radius: 24px;
  color: #fffbf2;
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.036px;
  text-transform: uppercase;
  box-shadow: inset 1px -3px 16px 0 rgba(255, 255, 255, 0.6);
  white-space: nowrap;
}

.tabNow {
  min-width: 76px;
  background: #f0930c;
}

.tabEverydoggy {
  min-width: 136px;
  background: #ae66f6;
}

.sections {
  display: flex;
  flex-direction: column;
}

.section {
  padding: 0 8px 16px;
}

.section + .section {
  padding-top: 16px;
  border-top: 1px solid #eae5da;
}

.section:last-child {
  padding-bottom: 0;
}

.sectionTitle {
  margin: 0 0 12px;
  color: #221e1a;
  font-family: 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.042px;
  text-transform: uppercase;
}

.barsRow {
  display: flex;
  gap: 16px;
}

.barGroup {
  display: flex;
  flex: 1 0 0;
  gap: 4px;
  min-width: 0;
}

.segmentTrack {
  position: relative;
  flex: 1 0 0;
  height: 9px;
  overflow: hidden;
  border-radius: 4px;
}

.segmentTrackOrange {
  background: rgba(240, 147, 12, 0.3);
}

.segmentTrackPurple {
  background: rgba(174, 102, 246, 0.3);
}

.segmentFill {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: 4px;
}

.segmentFillOrange {
  background: #f0930c;
}

.segmentFillPurple {
  background: #ae66f6;
}

